module.exports = __webpack_public_path__ + "img/bana.c8435c3f.png";